import React, {useImperativeHandle, useMemo, useReducer, useRef, useState} from 'react'
import WizModal from '../../../components/modal/WizModal'
import WizSelect from '../../../components/select/WizSelect'
import Text from '../../../components/text/Text'
import UnderLineInput from '../../../components/input/UnderLineInput'
import WizButton from '../../../components/button/WizButton'
import WizSelectButton from '../../../components/button/WizSelectButton'
import {createReferral} from '../../../apis/cashback/createReferral'

interface IProps {
    className?: string
    callback?: () => void
}

const initState = {
    exchange_maker_fee_rate: 0,
    exchange_taker_fee_rate: 0,
    max_reward_rate: 0,
    referral_code: '',
}

const CreateReferralModal = ({className, callback}: IProps, ref: any) => {
    const modalRef = useRef<any>()
    const [exchange, setExchange] = useState('')
    const [inputValue, setInputValue] = useState('')
    const [state, dispatch] = useReducer(reducer, initState)

    const {exchange_maker_fee_rate, exchange_taker_fee_rate, max_reward_rate, referral_code} = state

    function reducer(state, action) {
        switch (action.type) {
            case 'field_reset':
                return {
                    exchange_maker_fee_rate: 0,
                    exchange_taker_fee_rate: 0,
                    max_reward_rate: 0,
                    referral_code: '',
                }
            case 'field_update':
                return {...state, [action.field]: action.value}
        }
        return {...state}
    }

    const statusList = useMemo(
        () => [
            {id: 0, value: 'Hide'},
            {id: 1, value: 'Show'},
        ],
        [],
    )

    const [referralStatus, setReferralStatus] = useState(statusList[0])

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
            setExchange('')
            setInputValue('')
            setReferralStatus(statusList[0])
            dispatch({
                type: 'field_update',
                field: 'max_reward_rate',
                value: 0,
            })
            dispatch({
                type: 'field_update',
                field: 'exchange_maker_fee_rate',
                value: 0,
            })
            dispatch({
                type: 'field_update',
                field: 'exchange_taker_fee_rate',
                value: 0,
            })
        },
        close: () => {
            modalRef.current.close()
        },
    }))

    return (
        <>
            <WizModal title={'Create Referral'} className={`${className} min-h-[400px]`} ref={modalRef}>
                <section className={'flex justify-between flex-col h-full mt-[30px]'}>
                    <div className={'grid grid-cols-2 gap-x-[40px] gap-y-[40px] '}>
                        <div className={'col-span-2'}>
                            <Text className={'text-body2 text-font01 text-center'}>Exchange</Text>
                            <WizSelect
                                optionKey="exchange"
                                onChange={e => setExchange(e)}
                                value={exchange}
                                optionsClassName={'max-h-[200px] !overflow-auto mx-auto left-[50%] translate-x-[-50%]'}
                                buttonClassName={'mx-auto'}
                                className={'mt-[5px]'}
                            />
                        </div>
                        <div className={''}>
                            <Text className={'text-body3 text-font02'}>Cashback % (페이백율 %)</Text>
                            <UnderLineInput
                                inputClassName={'md:text-center'}
                                value={max_reward_rate}
                                onChanged={text =>
                                    dispatch({
                                        type: 'field_update',
                                        field: 'max_reward_rate',
                                        value: Number(text),
                                    })
                                }
                            />
                        </div>
                        <div className={''}>
                            <Text className={'text-body3 text-font02'}>Limit Order Fee (지정가 수수료)</Text>
                            <UnderLineInput
                                inputClassName={'md:text-center'}
                                value={exchange_maker_fee_rate}
                                onChanged={text =>
                                    dispatch({
                                        type: 'field_update',
                                        field: 'exchange_maker_fee_rate',
                                        value: Number(text),
                                    })
                                }
                            />
                        </div>
                        <div className={''}>
                            <Text className={'text-body3 text-font02'}>Market Commission (시장가 수수료)</Text>
                            <UnderLineInput
                                inputClassName={'md:text-center'}
                                value={exchange_taker_fee_rate}
                                onChanged={text =>
                                    dispatch({
                                        type: 'field_update',
                                        field: 'exchange_taker_fee_rate',
                                        value: Number(text),
                                    })
                                }
                            />
                        </div>

                        <div className={''}>
                            <Text className={'text-body3 text-font02'}>Referral Code</Text>
                            <UnderLineInput
                                value={inputValue}
                                onChanged={text => {
                                    setInputValue(text)
                                }}
                                inputClassName={'md:text-center'}
                            />
                        </div>
                        <div className={'col-span-2'}>
                            <Text className={'text-body3 text-font02 text-center'}>Referral Status</Text>
                            <WizSelectButton
                                data={statusList}
                                onChange={item => {
                                    setReferralStatus(item)
                                }}
                                activeValue={referralStatus}
                                className={'mx-auto'}
                            />
                        </div>
                    </div>
                    <div className={'text-center'}>
                        <WizButton
                            text={'Create Referral Exchange'}
                            onClick={async () => {
                                const {status} = await createReferral({
                                    exchange: exchange,
                                    exchange_maker_fee_rate: exchange_maker_fee_rate,
                                    exchange_taker_fee_rate: exchange_taker_fee_rate,
                                    max_reward_rate: max_reward_rate,
                                    status: referralStatus?.id,
                                    referral_code: inputValue,
                                })
                                if (status === 5092) {
                                    alert('This exchange has already been created.')
                                } else if (status === 5004) {
                                    alert(
                                        'Some required fields are missing — the exchange and referral code are require',
                                    )
                                } else {
                                    alert('Complete Create Referral!')
                                    modalRef?.current?.close()
                                }
                                callback()
                            }}
                            className={'mx-auto mt-[40px]'}
                            type={'primary'}
                        />
                    </div>
                </section>
            </WizModal>
        </>
    )
}

export default React.forwardRef(CreateReferralModal)
